import { sendPhoneCode } from '@/api/user/user';

export default {
  data() {
    return {
      countdown: 60,
      sendMsgBtnStatus: 0, // 0: 未发送，1: 发送中，2: 倒计时，3: 再次发送
      timer: null,
      isValidatePhone: false,
    };
  },
  computed: {
    sendMsgBtnText() {
      return ['发送验证码', '发送中', `再发一次${this.countdown}s`, '再发一次'][this.sendMsgBtnStatus];
    },
    isSendMsgBtnDisabled() {
      return [1, 2].indexOf(this.sendMsgBtnStatus) > -1 || !this.isValidatePhone;
    },
  },
  methods: {
    handleValidateFormItem(prop, status) {
      if (prop === 'phone') {
        this.isValidatePhone = status;
      }
    },
    async handleSendMsg() {
      this.sendMsgBtnStatus = 1;
      // 调用后端发送验证码接口
      const res = await sendPhoneCode({
        phone: this.formData.phone,
      });
      if (res) {
        this.$Message.success('发送成功');
        this.sendMsgBtnStatus = 2;
        this.timer = setInterval(() => {
          this.countdown -= 1;
          if (this.countdown <= 0) {
            this.sendMsgBtnStatus = 3;
            clearInterval(this.timer);
            this.countdown = 60;
          }
        }, 1000);
      } else {
        this.sendMsgBtnStatus = 3;
      }
    },
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
};
